/**
 * 前端全局运行时配置。
 * 容器部署优先读取 runtime-config.js，本地开发回落到 Vite 环境变量。
 * 默认走 `/api/admin`，作为 requestClient 的 baseURL。
 */
import { runtimeConfig } from "@/runtime-config";

const apiBaseUrl = (
  runtimeConfig.apiBaseUrl?.trim() ||
  import.meta.env.VITE_API_BASE_URL?.trim() ||
  "/api/admin"
).replace(/\/$/, "");

export const GLOBAL_CONFIG = {
  apiBaseUrl,
};
